"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IStrengthOrRunOrCycleOrRow = void 0;
var IStrengthOrRunOrCycleOrRow;
(function (IStrengthOrRunOrCycleOrRow) {
    IStrengthOrRunOrCycleOrRow["Strength"] = "strength";
    IStrengthOrRunOrCycleOrRow["Run"] = "run";
    IStrengthOrRunOrCycleOrRow["Cycle"] = "cycle";
    IStrengthOrRunOrCycleOrRow["Row"] = "row";
})(IStrengthOrRunOrCycleOrRow || (exports.IStrengthOrRunOrCycleOrRow = IStrengthOrRunOrCycleOrRow = {}));
//# sourceMappingURL=strength-or-run-or-cycle-or-row.js.map